module.exports = __webpack_public_path__ + "./kit/docs/img/icon-github.d98f2a6c334063029b17bce71b12ddd8.svg";